import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface AuthenticatorAppDownload {
  name: string;
  iconUrl: string;
  iosUrl: string;
  androidUrl: string;
}

@Component({
  selector: 'app-mfa-authenticator-app-modal',
  standalone: false,
  templateUrl: './mfa-authenticator-app-modal.component.html',
  styleUrls: ['./mfa-authenticator-app-modal.component.scss'],
})
export class MfaAuthenticatorAppModalComponent {
  @Input() app!: AuthenticatorAppDownload;

  readonly appStoreBadgeUrl = '/assets/img/app-store-badge.svg';
  readonly googlePlayBadgeUrl = '/assets/img/google-play-badge.png';

  constructor(public activeModal: NgbActiveModal) {}
}
